import { render, staticRenderFns } from "./PopupPrompt.vue?vue&type=template&id=f94fc22a&scoped=true&lang=pug&"
import script from "./PopupPrompt.vue?vue&type=script&lang=js&"
export * from "./PopupPrompt.vue?vue&type=script&lang=js&"
import style0 from "./PopupPrompt.vue?vue&type=style&index=0&id=f94fc22a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94fc22a",
  null
  
)

export default component.exports